module.exports = __webpack_public_path__ + "media/img/pole_a@3x-41059382.svg";